"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CardLabel = _interopRequireDefault(require("./CardLabel"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./Card.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Card = function Card(_ref) {
  var _cx;

  var id = _ref.id,
      state = _ref.state,
      _ref$side = _ref.side,
      side = _ref$side === void 0 ? 'front' : _ref$side,
      suit = _ref.suit,
      label = _ref.label,
      trump = _ref.trump,
      deck = _ref.deck,
      onClick = _ref.onClick;
  var cls = (0, _classnames["default"])('card', (_cx = {}, _defineProperty(_cx, "card--".concat(side), side), _defineProperty(_cx, "card--".concat(state), state), _defineProperty(_cx, 'card--trump', trump), _defineProperty(_cx, 'card--deck', deck), _cx));
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: cls,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_CardLabel["default"], {
    suit: suit,
    label: label,
    position: "top"
  }), /*#__PURE__*/_react["default"].createElement(_CardLabel["default"], {
    suit: suit,
    label: label,
    position: "bottom"
  }));
};

Card.propTypes = {
  id: _propTypes["default"].string,
  state: _propTypes["default"].string,
  side: _propTypes["default"].oneOf(['front', 'back']),
  suit: _propTypes["default"].oneOf(['clubs', 'spades', 'diamonds', 'hearts']),
  label: _propTypes["default"].string,
  trump: _propTypes["default"].bool,
  deck: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
var _default = Card;
exports["default"] = _default;